import { Link } from 'react-router-dom';
import { Calendar, BookOpen, Megaphone } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { AutoTranslate } from '../../hooks/useAutoTranslate';
import { useLanguage } from '../../context/LanguageContext';
import { useEventsModule } from '../../context/EventsModuleContext';

// Three quick-action cards overlaying the hero (Liturgi / Bible / Meddelanden).
const QuickActions = () => {
  const { t } = useLanguage();
  const { eventsEnabled } = useEventsModule();

  return (
    <section className="-mt-16 relative z-10" data-testid="quick-actions-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Link to="/liturgi" className="card-hover" data-testid="quick-action-liturgi">
            <Card className="bg-white shadow-xl border-0">
              <CardContent className="p-6 flex items-center space-x-4">
                <div className="w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center">
                  <Calendar className="w-7 h-7 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-serif font-bold text-lg text-gray-900"><AutoTranslate>Liturgi</AutoTranslate></h3>
                  <p className="text-sm text-gray-600">{t('massScheduleDesc')}</p>
                </div>
              </CardContent>
            </Card>
          </Link>
          <Link to="/bible" className="card-hover" data-testid="quick-action-readings">
            <Card className="bg-white shadow-xl border-0">
              <CardContent className="p-6 flex items-center space-x-4">
                <div className="w-14 h-14 rounded-full bg-green-100 flex items-center justify-center">
                  <BookOpen className="w-7 h-7 text-green-600" />
                </div>
                <div>
                  <h3 className="font-serif font-bold text-lg text-gray-900">{t('todayReading')}</h3>
                  <p className="text-sm text-gray-600">{t('todayReadingsDesc')}</p>
                </div>
              </CardContent>
            </Card>
          </Link>
          <Link to="/events" className="card-hover" data-testid="quick-action-meddelanden">
            <Card className="bg-white shadow-xl border-0">
              <CardContent className="p-6 flex items-center space-x-4">
                <div className="w-14 h-14 rounded-full bg-yellow-100 flex items-center justify-center">
                  <Megaphone className="w-7 h-7 text-yellow-600" />
                </div>
                <div>
                  <h3 className="font-serif font-bold text-lg text-gray-900"><AutoTranslate>Meddelanden</AutoTranslate></h3>
                  {eventsEnabled && (
                    <p className="text-sm text-gray-600"><AutoTranslate>och kalendern</AutoTranslate></p>
                  )}
                </div>
              </CardContent>
            </Card>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default QuickActions;
